var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'message-no-header': true, 'full-width': _vm.fullwidth }},[_c('b-message',_vm._b({staticClass:"has-shadow"},'b-message',_vm.$props,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }